module.exports = __webpack_public_path__ + "static/img/Maple Espresso.a6c14c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/color/Maple Espresso.jpg
// module id = +oXu
// module chunks = 0